import React from 'react'
import { Helmet } from 'react-helmet'
import Component from 'components/component'
import { DI } from 'modules'
import frontload from 'hoc/frontload'
import page from 'hoc/page'
import AEFilter from 'components/ae-filter'
import PageSubmenu from 'components/page-submenu'
import { ActionCableConsumer } from 'components/action-cable-wrapper'

import List, { LiveItemAdapter } from 'components/list'
import { Group, Groups } from 'components/list/group'

import Empty from './empty'

import 'submodules/responsivestyles/src/less/all-events.less'

export class MyEvents extends Component {
  static preload(props, isChangedLocale) {
    const slug = 'events'
    const preloadList = [props.actions.lives.getListMyEvents()]

    const {
      frontpages: {
        info: { payload: tag },
      },
    } = props

    if (tag.slug !== slug || isChangedLocale) {
      preloadList.concat([props.actions.frontpages.getFrontPage(slug)])
    }

    return Promise.all(preloadList)
  }

  componentDidMount() {
    MyEvents.preload(this.props)
  }

  componentDidUpdate(prevProps) {
    const localeIsUpdated = this.props.common.locale !== prevProps.common.locale

    if (localeIsUpdated) {
      MyEvents.preload(this.props, true)
    }
  }

  onReceivedWebsocket = msg => {
    this.props.actions.lives.wsStatusChangeMyEvents(msg.data)
  }

  onStreamItemClick = event => {
    if (this.props.user?.isSignedIn && !this.props.user?.country?.name) {
      event.preventDefault()

      this.props.actions.notifications.createNotification({
        type: 'error',
        children: this.props.common.strings['page.events.counry_missing_error'],
      })
    }
  }

  string = key => this.props.common.strings[key]

  render() {
    const pageTitle = this.string('page.my_event.title')
    const events = this.props.lives.listMyEvents.payload
    const booked = events.booked_events || []
    const followed = events.followed_events || []
    const submenu = this.props.menu.mainMenu.length
      ? this.props.menu.mainMenu[1].children
      : []

    if (
      this.props.lives.listMyEvents.isInited &&
      !this.props.lives.listMyEvents.pending &&
      !booked.length &&
      !followed.length
    ) {
      return <Empty pageTitle={pageTitle} submenu={submenu} />
    }

    return (
      <section className="content">
        <ActionCableConsumer
          channel="Content::LiveEventsChannel"
          onReceived={this.onReceivedWebsocket}
        />
        <Helmet title={`${pageTitle} - ${events.count}`} />
        <IWrap separator={booked.length && followed.length}>
          <PageSubmenu items={submenu} />
          <div className="page-title">{this.string('page.my_event.title')}</div>
          <AEFilter livesCount={events.count} />
          {!!booked.length && (
            <Groups>
              <Group subtitle={this.string('page.my_event.title.booked')}>
                <List>
                  {booked.map(item => (
                    <LiveItemAdapter
                      key={item.id}
                      live={item}
                      onClick={this.onStreamItemClick}
                    />
                  ))}
                </List>
              </Group>
            </Groups>
          )}
        </IWrap>
        {!!followed.length && (
          <IWrap>
            <Groups>
              <Group
                subtitle={this.string('page.my_event.title.following')}
                text={this.string('page.my_event.title.following.content')}
              >
                <List>
                  {followed.map(item => (
                    <LiveItemAdapter
                      key={item.id}
                      live={{
                        ...item,
                        subscribed: true,
                      }}
                      onClick={this.onStreamItemClick}
                    />
                  ))}
                </List>
              </Group>
            </Groups>
          </IWrap>
        )}
      </section>
    )
  }
}

function IWrap({ separator, children }) {
  return (
    <div
      className={Component.classList('iwrap', separator && 'iwrap--separator')}
    >
      {children}
    </div>
  )
}

export default page(
  DI([
    'user',
    'lives',
    'locales',
    'common',
    'menu',
    'frontpages',
    'notifications',
  ])(frontload(MyEvents))
)
